import { render, staticRenderFns } from "./PayPalCasesTableMobile.vue?vue&type=template&id=2185d57d&scoped=true"
import script from "./PayPalCasesTableMobile.vue?vue&type=script&lang=js"
export * from "./PayPalCasesTableMobile.vue?vue&type=script&lang=js"
import style0 from "./PayPalCasesTableMobile.vue?vue&type=style&index=0&id=2185d57d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2185d57d",
  null
  
)

export default component.exports